var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"humidity"},[_vm._v("\n  "+_vm._s((_vm.data.value !== null && typeof _vm.data.value !== `undefined` )
    ? _vm.data.value.toFixed(2) +'%' : ' '))])
}
var staticRenderFns = []

export { render, staticRenderFns }